var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "custom-control custom-radio custom-control-inline" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.direction,
                expression: "direction",
              },
            ],
            staticClass: "custom-control-input",
            attrs: { value: "1", type: "radio", id: "dirImport", name: "dir" },
            domProps: { checked: _vm._q(_setup.direction, "1") },
            on: {
              change: function ($event) {
                _setup.direction = "1"
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom-control-label",
              attrs: { for: "dirImport" },
            },
            [_vm._v("Read data from connector")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "custom-control custom-radio custom-control-inline" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.direction,
                expression: "direction",
              },
            ],
            staticClass: "custom-control-input",
            attrs: { value: "2", type: "radio", id: "dirExport", name: "dir" },
            domProps: { checked: _vm._q(_setup.direction, "2") },
            on: {
              change: function ($event) {
                _setup.direction = "2"
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom-control-label",
              attrs: { for: "dirExport" },
            },
            [_vm._v("Write data to connector")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "Name" } }, [_vm._v("Name:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.name,
                expression: "name",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Name of a pipeline" },
            domProps: { value: _setup.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.name = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "Name", errors: _setup.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "Description" } }, [
            _vm._v("Description:"),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.description,
                expression: "description",
              },
            ],
            staticClass: "form-control",
            attrs: { placeholder: "Description of a pipeline" },
            domProps: { value: _setup.description },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.description = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "Description", errors: _setup.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-primary btn-lg", on: { click: _setup.invoke } },
        [_vm._v("Create")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Create a new integration pipeline")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }